import { UserRole } from "../../Profile/enums/profileEnums";

export const ROLE_HIERARCHY: UserRole[] = [
  UserRole.COMPANY_ADMIN,
  UserRole.STORE_ADMIN,
  UserRole.WAREHOUSE_MANAGER,
  UserRole.INVENTORY_CLERK,
  UserRole.SALES_PROCUREMENT,
  UserRole.BUYER,
  UserRole.ANALYST
];
